import { useState } from "react";
import { getKudosDetails, IKudosDetails } from "../services/apis/KudosApi";
import { useFetchKudosMetadata } from "./useFetchKudosMetadata";

export const useKudosDetails = (
  tokenId: string,
  prefetchedKudosDetails?: IKudosDetails,
  initLoading?: boolean,
) => {
  const [loading, setLoading] = useState(initLoading ? true : false);
  const [error, setError] = useState<Error | null>(null);
  const [kudosDetails, setKudosDetails] = useState<IKudosDetails | null>(null);

  const {
    fetchContributors,
    fetchOwners,
    fetchMetadata,
    contributors,
    contributorsResponse,
    ownersResponse,
    owners,
    endorsers,
  } = useFetchKudosMetadata(tokenId || String(kudosDetails?.tokenId) || "");

  async function fetchKudosDetails(
    kudosId: string,
    abortController?: AbortController,
  ) {
    setLoading(true);
    setError(null);
    try {
      // Don't fetch again if details were already passed from server side
      if (!prefetchedKudosDetails?.headline) {
        const data = await getKudosDetails(
          kudosId,
          // @ts-ignore
          abortController ? abortController.signal : null,
        );
        setKudosDetails(data);
      }

      await fetchMetadata();
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      setError(err);
      throw err;
    }
  }

  return {
    loading,
    error,
    kudosDetails,
    fetchKudosDetails,
    contributors,
    contributorsResponse,
    fetchContributors,
    ownersResponse,
    owners,
    fetchOwners,
    endorsers,
  };
};
